import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '../assets/team.png'


const _hoisted_1 = { class: "about" }
const _hoisted_2 = { class: "service-area" }
const _hoisted_3 = { class: "card" }
const _hoisted_4 = {
  href: "tel:+496975009899",
  class: "call-button"
}
const _hoisted_5 = { class: "placement" }
const _hoisted_6 = { class: "map-card" }
const _hoisted_7 = {
  key: 0,
  style: {"border":"0"},
  loading: "lazy",
  allowfullscreen: "",
  src: "https://www.google.com/maps?q=Herxheimerstraße 17, 60326 Frankfurt am Main&output=embed"
}
const _hoisted_8 = {
  key: 1,
  class: "map-placeholder"
}

import '@/assets/styles/about.css'
import {Phone} from "lucide-vue-next";
import * as CookieConsent from 'vanilla-cookieconsent';
import {onMounted, ref} from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'AboutView',
  setup(__props) {


/**
 *
 */
const acceptedGoogleMaps = ref(false);

function updateConsent() {
  acceptedGoogleMaps.value =
      CookieConsent.acceptedCategory("external");
}

function openCookieSettings() {
  CookieConsent.showPreferences();
}

onMounted(() => {
  const sync = () => {
    acceptedGoogleMaps.value =
        CookieConsent.acceptedCategory("external");
  };

  sync();

  setInterval(sync, 500); // robust fallback
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[3] || (_cache[3] = _createStaticVNode("<section class=\"team\"><div class=\"team-wrapper\"><h1>Meet the Team!</h1><div class=\"card\"><img src=\"" + _imports_0 + "\" alt=\"Team\" class=\"card-image\"><div class=\"team-intro\"><h3>Wir sind für sie da</h3><p> Der Mensch steht bei uns im Mittelpunkt. Unser Ziel ist es, unseren Kundinnen und Kunden eine individuelle, respektvolle und professionelle Versorgung in ihrer vertrauten häuslichen Umgebung zu ermöglichen. Seit über 20 Jahren sind wir im Frankfurter Raum als zuverlässiger ambulanter Pflegedienst tätig und begleiten Menschen mit Erfahrung, Kompetenz und Menschlichkeit im Alltag. Als familiengeführtes Unternehmen legen wir besonderen Wert auf persönliche Nähe, Vertrauen und einen respektvollen Umgang miteinander. Die langjährige Zusammenarbeit mit Kundinnen und Kunden, Angehörigen sowie medizinischen Einrichtungen steht für Qualität, Beständigkeit und Verlässlichkeit. Mit Herz, Fachwissen und Verantwortungsbewusstsein unterstützen wir Menschen dabei, ihre Lebensqualität und Selbstständigkeit so lange wie möglich zu erhalten. Dabei steht der Mensch mit seinen individuellen Bedürfnissen und Wünschen stets im Mittelpunkt unseres Handelns. Unsere Pflege und Betreuung orientiert sich an den persönlichen Gewohnheiten und Lebenssituationen unserer Kundinnen und Kunden. Gemeinsam mit ihnen sowie ihren Angehörigen entwickeln wir passende Lösungen für eine bestmögliche Versorgung. Besonders wichtig ist uns die Wahrung der Privatsphäre. Als Gast im Zuhause unserer Kundinnen und Kunden handeln wir einfühlsam, diskret und zuverlässig. Durch regelmäßige Fort- und Weiterbildungen stellen wir sicher, dass unser Team stets nach aktuellen pflegerischen Standards arbeitet und eine qualitativ hochwertige Versorgung gewährleistet wird. Offenheit, Toleranz und Wertschätzung gegenüber Menschen unterschiedlicher Kulturen und Lebensweisen sind für uns selbstverständlich. Wir begegnen jedem Menschen mit Achtung und Respekt. Mit unserem Engagement und unserer langjährigen Erfahrung möchten wir unseren Kundinnen und Kunden sowie deren Angehörigen Sicherheit, Unterstützung und Vertrauen im Alltag geben. </p><p> Vertrauen, Menschlichkeit und fachliche Qualität stehen bei uns an erster Stelle – für Sie und Ihre Angehörigen. </p></div></div></div></section><section class=\"opening-hours\"><div class=\"card\"><h2>Öffnungszeiten</h2><ul class=\"opening-list\"><li><span>Bürozeiten</span><span>Montag – Mittwoch, 08:00 – 17:00 Uhr</span></li><li><span>Rufbereitschaft</span><span>24 Stunden / 7 Tage erreichbar</span></li></ul><p class=\"opening-hint\"> Termine außerhalb der Öffnungszeiten sind nach Vereinbarung möglich. </p></div></section>", 2)),
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[1] || (_cache[1] = _createStaticVNode("<h2>Unser Einzugsgebiet</h2><p> Unser ambulanter Pflegedienst ist im Raum Frankfurt und Umgebung für Sie im Einsatz. Wir versorgen unsere Patientinnen und Patienten zuverlässig direkt in ihrem Zuhause. </p><ul class=\"area-list\"><li>Frankfurt am Main</li><li>Gallusviertel</li><li>Griesheim</li><li>Höchst</li><li>Nied</li><li>Schwanheim</li><li>Sossenheim</li><li>Zeilsheim</li><li>Sindlingen</li><li>Niederrad</li><li>Goldstein</li><li>Westend</li><li>Gutleutviertel</li><li>Sachsenhausen</li></ul><p class=\"area-hint\"> Sie wohnen in der Nähe und sind sich unsicher, ob wir zu Ihnen kommen? Kontaktieren Sie uns gerne – wir prüfen das individuell. </p>", 4)),
        _createElementVNode("a", _hoisted_4, [
          _createVNode(_unref(Phone)),
          _cache[0] || (_cache[0] = _createTextVNode(" Rufen Sie uns an! ", -1))
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        (acceptedGoogleMaps.value)
          ? (_openBlock(), _createElementBlock("iframe", _hoisted_7))
          : (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _cache[2] || (_cache[2] = _createElementVNode("p", null, "Google Maps ist deaktiviert", -1)),
              _createElementVNode("button", { onClick: openCookieSettings }, " Einstellungen öffnen ")
            ]))
      ])
    ])
  ]))
}
}

})